import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { LoginModel } from "@/views/authenticate/authenticate.types";

@Component({
  computed: {
    ...mapState("Authenticate", [
      "user"
    ])
  }
})
export default class AuthenticateMixin extends Vue {
  user!: LoginModel;
}